export default "__VITE_ASSET__g2oMRQeBX0EhfZ_9hdfvJw__"